import { InputNumber } from 'antd';
/**
 *
 * styled
 *
 */
import styled from 'styled-components/macro';

export const InputNumberContainerWrapper = styled.div`
  input {
    font-size: 14px !important;
  }
`;

export const StyledInputNumber = styled(InputNumber)`
  .ant-input-number-focused {
    box-shadow: none;
  }
  .ant-input-number {
    box-shadow: none !important;
  }
  .ant-input-number-out-of-range input {
    color: inherit;
  }
`;
